import Req from '../../$axios';

const serviceModule = {
  // 添加清单
  addChecklist(params) {
    return Req(
      {
        url: 'tasklist/addtasklist/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 编辑清单
  editChecklist(params) {
    return Req(
      {
        url: 'tasklist/updatetasklist/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // deletetasklist
  deletetasklist(params) {
    return Req(
      {
        url: 'tasklist/deletetasklist/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 移动清单
  updateorderby(params) {
    return Req(
      {
        url: 'tasklist/updateorderby/',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: false
      },
      params
    )
  },
  // 任务列表
  getTaskList(params) {
    return Req(
      {
        url: 'task/index/',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 添加任务
  addTask(params) {
    return Req(
      {
        url: 'task/addtask/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 编辑任务
  editTask(params) {
    return Req(
      {
        url: 'task/updatetask/',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除任务
  delTask(params) {
    return Req(
      {
        url: 'tasks/delete',
        method: 'delete',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 移动任务
  updateTaskOrderby(params) {
    return Req(
      {
        url: 'task/updateorderby/',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取任务详细
  gettaskinfo(params) {
    return Req(
      {
        url: 'task/gettaskinfo/',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 更新任务成员
  updatetasktmember(params) {
    return Req(
      {
        url: 'task/updatetasktmember/',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取任务的评论
  getTaskComment(params) {
    return Req(
      {
        url: 'taskComments',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取任务日志
  getTaskLogList(params) {
    return Req(
      {
        url: 'task/getlog/',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 给任务发布评论
  postTaskComments(params) {
    return Req(
      {
        url: 'taskComments',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取归档的任务列表
  getArchivedTaskList(params) {
    return Req(
      {
        url: 'archived/tasklist/',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  //归档任务
  archivedTask(params) {
    return Req(
      {
        url: 'archived/task/',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 激活任务
  activateTask(params) {
    return Req(
      {
        url: 'archived/opentask/',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 自定义字段
  // 获取项目下面的任务
  userIndexForProjectToSimple(params = {}) {
    let data = {
      ...params,
      api_version: 'v2',
    }
    return Req(
      {
        url: ' users/userIndexForProjectToSimple',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      data
    )
  },
  getProjectTaskList(params = {}) {
    let data = {
      api_version: 'v2',
      ...params
    }
    return Req(
      {
        url: 'tasklist/index',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      data
    )
  },
  // 获取任务排序规则
  getTaskSortList(params) {
    return Req(
      {
        url: 'tasksSortRules/index',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 新增任务
  saveTaskatNew(params) {
    return Req(
      {
        url: 'tasks/save',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 更新任务
  updateTaskView(params) {
    return Req(
      {
        url: 'tasks/update',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 删除任务
  deleteTaskNewView(params) {
    return Req(
      {
        url: 'tasks/delete',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取子任务
  childrenTasksIndex(params) {
    let data = {
      api_version: 'v2',
      ...params
    }
    return Req(
      {
        url: 'tasks/childrenTasksIndex',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      data
    )
  },
  // 获取筛选列表
  getFilterData(params) {
    return Req(
      {
        url: 'project/getFilter',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 移动项目
  updateTaskSort(params) {
    return Req(
      {
        url: 'tasks/updateTaskSort',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  batchUpdateTaskStage(params) {
    return Req(
      {
        url: 'tasks/batchUpdateTaskStage',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  batchDeleteTasks(params) {
    return Req(
      {
        url: 'tasks/batchDeleteTasks',
        method: 'post',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取清单下任务列表
  getNumberTaskList(params) {
    let data = {
      api_version: 'v2',
      ...params
    }
    return Req(
      {
        url: 'tasks/index',
        method: 'get',
        isJSON: true,
        tip: true,
        isAlertErr: true
      },
      data
    )
  },
  // 获取任务详情
  getTaskDetail(params) {
    let data = {
      api_version: 'v2',
      ...params
    }
    return Req(
      {
        url: 'tasks/read',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      data
    )
  },
  // 获取项目成员
  getProjectMembers(params) {
    return Req(
      {
        url: 'project/getProjectMembers',
        method: 'get',
        isJSON: true,
        tip: true,
        isAlertErr: true
      },
      params
    )
  },
  //获取任务参与人
  getTaskMembers(params) {
    return Req(
      {
        url: 'tasks/getTaskMembers',
        method: 'get',
        isJSON: true,
        tip: true,
        isAlertErr: true
      },
      params
    )
  },
  taskIndexUnderTheProject(params) {
    return Req(
      {
        url: 'tasks/taskIndexUnderTheProject',
        method: 'get',
        isJSON: false,
        tip: true,
        isAlertErr: true
      },
      params
    )
  },
  updateTaskStage(params) {
    // 更新任务状态
    return Req(
      {
        url: 'tasks/updateTaskStage',
        method: 'post',
        isJSON: true,
        tip: true,
        isAlertErr: true
      },
      params
    )
  },
  download(params) {
    // 下载文件
    return Req(
      {
        url: 'attachments/download',
        method: 'get',
        isJSON: true,
        tip: true,
        isAlertErr: true
      },
      params
    )
  },
  userProjectProgressOverview(params) {
    // 用户项目进度统计
    return Req(
      {
        url: 'statistic/userProjectProgressOverview',
        method: 'get',
        isJSON: true,
        tip: true,
        isAlertErr: true
      },
      params
    )
  },
  projectTaskIndex(params) {
    // 某个项目下任务列表(用于列表和甘特图)
    let data = {
      api_version: 'v2',
      ...params
    }
    return Req(
      {
        url: 'tasks/projectTaskIndex',
        method: 'get',
        isJSON: false,
        tip: true,
        isAlertErr: true
      },
      data
    )
  },
  taskListToSimpleIndex(params) {
    // 某个项目下任务列表(用于列表和甘特图)
    let data = {
      api_version: 'v2',
      ...params
    }
    return Req(
      {
        url: 'tasklist/taskListToSimpleIndex',
        method: 'get',
        isJSON: false,
        tip: true,
        isAlertErr: true
      },
      data
    )
  },
  //设置当前任务及子任务未读消息已读(新)
  setNewTaskAndChildrenTaskMessageRead(params) {
    return Req(
      {
        url: 'projectMessages/setTaskAndChildrenTaskMessageRead',
        method: 'post',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 项目所有执行人
  userIndexForProjectToSimple(params) {
    return Req(
      {
        url: 'users/userIndexForProjectToSimple',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  projectUserTaskIndex(params) {
    return Req(
      {
        url: 'tasks/projectUserTaskIndex',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  }
}

export default {
  ...serviceModule
};
